import { render } from "./activityDetail.vue?vue&type=template&id=7c4c7902&scoped=true&ts=true"
import script from "./activityDetail.vue?vue&type=script&lang=ts"
export * from "./activityDetail.vue?vue&type=script&lang=ts"

import "./activityDetail.vue?vue&type=style&index=0&id=7c4c7902&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c4c7902"]])

export default __exports__